import { cn } from "~/lib/utils";

interface Props {
  children: React.ReactNode;
  className?: string;
}
const CustomFormWrapper = ({ children, className }: Props) => {
  return (
    <div
      className={cn(
        "max-h-[calc(100vh-15rem)] w-full space-y-6 overflow-y-auto",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default CustomFormWrapper;
